'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('styles/main.scss');
require('styles/progress-bar.scss');

var ProgressBarComponent = function (_React$Component) {
  _inherits(ProgressBarComponent, _React$Component);

  function ProgressBarComponent() {
    _classCallCheck(this, ProgressBarComponent);

    return _possibleConstructorReturn(this, (ProgressBarComponent.__proto__ || Object.getPrototypeOf(ProgressBarComponent)).apply(this, arguments));
  }

  _createClass(ProgressBarComponent, [{
    key: 'stepComplete',
    value: function stepComplete(step) {
      var step_number = parseInt(this.props.stepNumber);
      if (step_number > step) {
        return 'col-xs-4 bs-wizard-step complete';
      } else if (step_number === step) {
        return 'col-xs-4 bs-wizard-step active';
      }
      return 'col-xs-4 bs-wizard-step disabled';
    }
  }, {
    key: 'toggleStep',
    value: function toggleStep(step) {
      if (this.props.step < step) {
        this.props.setStep(step);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row bs-wizard' },
          _react2.default.createElement(
            'div',
            { className: this.stepComplete(0) },
            _react2.default.createElement(
              'div',
              { className: 'text-center bs-wizard-stepnum' },
              '1. Get Quote'
            ),
            _react2.default.createElement(
              'div',
              { className: 'progress' },
              _react2.default.createElement('div', { className: 'progress-bar' })
            ),
            _react2.default.createElement('a', { href: '#', className: 'bs-wizard-dot' })
          ),
          _react2.default.createElement(
            'div',
            { className: this.stepComplete(1) },
            _react2.default.createElement(
              'div',
              { className: 'text-center bs-wizard-stepnum step2-text' },
              '2. Complete Application'
            ),
            _react2.default.createElement('a', { href: '#', className: 'bs-wizard-dot' })
          ),
          _react2.default.createElement(
            'div',
            { className: this.stepComplete(2) },
            _react2.default.createElement(
              'div',
              { className: 'text-center bs-wizard-stepnum step3-text' },
              '3. Confirmation'
            ),
            _react2.default.createElement(
              'div',
              { className: 'progress' },
              _react2.default.createElement('div', { className: 'progress-bar' })
            ),
            _react2.default.createElement('a', { href: '#', className: 'bs-wizard-dot' })
          )
        )
      );
    }
  }]);

  return ProgressBarComponent;
}(_react2.default.Component);

ProgressBarComponent.displayName = 'ProgressBarComponent';

exports.default = ProgressBarComponent;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ProgressBarComponent.js
// module id = 1647
// module chunks = 0